/**
 * Создаёт объекты results / loading / error для списка request_type.
 * @param {string[]} requestTypes
 */
export function createSearchFieldMaps(requestTypes) {
  return {
    results: Object.fromEntries(requestTypes.map((type) => [type, ''])),
    loading: Object.fromEntries(requestTypes.map((type) => [type, false])),
    error: Object.fromEntries(requestTypes.map((type) => [type, null])),
  };
}

/**
 * Редьюсеры для полей поиска (loading / results / error / clear).
 * @param {object} reducers — объект reducers для createSlice
 * @param {string[]} requestTypes
 */
export function appendSearchFieldReducers(reducers, requestTypes) {
  reducers.setLoadingForType = (state, action) => {
    const { requestType, value } = action.payload;
    state.loading[requestType] = value;
  };

  reducers.setResultsForType = (state, action) => {
    const { requestType, result } = action.payload;
    state.results[requestType] = result;
  };

  reducers.setErrorForType = (state, action) => {
    const { requestType, error } = action.payload;
    state.error[requestType] = error;
  };

  reducers.clearSearchResults = (state) => {
    const maps = createSearchFieldMaps(requestTypes);
    state.results = maps.results;
    state.loading = maps.loading;
    state.error = maps.error;
  };

  return reducers;
}
